<template>
<div class="vm-input" :class="[
    {'vm-input-maxbo': maxbo},
    {'vm-input-bold': bold},
    {'vm-input-disabled': disabled},
    {'vm-input-valid': valid},
    {'vm-input-invalid': invalid},
    {'vm-input-highlight': highlight},
    {'vm-input-borderless': borderless},
    {'vm-input-password': password}
]">
    <input :value="value" :placeholder="placeholder" @input="handleInput" :type="password ? 'password' : ''" :disabled="disabled" />
</div>
</template>
<script>

export default {
name: 'vm-input',
props: {
    value: [String, Number],
    placeholder: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    maxbo: {
        type: Boolean,
        default: false
    },
    borderless: {
        type: Boolean,
        default: false
    },
    bold: {
        type: Boolean,
        default: false
    },
    valid: {
        type: Boolean,
        default: false
    },
    invalid: {
        type: Boolean,
        default: false
    },
    highlight: {
        type: Boolean,
        default: false
    },
    password: {
        type: Boolean,
        default: false
    }
},
data() {
    return {
        
    }
},
methods: {
    handleInput(e) {
        this.$emit('input', e.srcElement.value);
    }
}
}
</script>
<style scoped>

.vm-input {
    position: relative;
    float: left;
    width: 100%;
}

.vm-input input {
    border: none;
    background: none;
    outline: none;
    width: 100%;
    padding: 7px 10px;
    padding-top: 9px;
    font-size: 15px;
    color: black;
    border-radius: 3px;
    border: solid 1px lightgray;
    box-sizing: border-box;
}

.vm-input-maxbo input {
    color: #234875;
    border-radius: 0px;
    border-bottom: solid 2px #004976;
}

.vm-input-disabled input {
    background-color: #eaecef;
}

.vm-input-valid input {
    background-color: #C6EAD2;
}
.vm-input-invalid input {
    background-color: #F7CECB;
}

.vm-input-highlight input {
    color: red;
}

.vm-input-bold input {
    font-weight: bold;
}

.vm-input-borderless input {
    padding-bottom: 7px;
    border: solid 1px lightgray;
}

</style>
